module.exports = __webpack_public_path__ + "media/images/icon_angle_down-0d74b6fff2938231a584c16736ba76d4.png";